import { render, staticRenderFns } from "./CreateNewFacility.vue?vue&type=template&id=7bdc161c&scoped=true&"
import script from "./CreateNewFacility.vue?vue&type=script&lang=js&"
export * from "./CreateNewFacility.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewFacility.vue?vue&type=style&index=0&id=7bdc161c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdc161c",
  null
  
)

export default component.exports